const Settings = {
   $body: $('body'),
   $html: $('html'),
   $headerHamburger: $('.hamburger'),
   $headerWrap: $('.header-wrap'),
   $mobileMenuWrap: $('.mobile-menu-wrap'),
   $headerImage: $('.header-img')
};

export default Settings;